import React from 'react';
import './Header.css';

function Header() {
  return (
    <header>
      <h1>Palindrome Coaching, Consulting, and Advising Services</h1>
      <nav>
        <ul>
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;